import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSEO } from '../hooks/useSEO';
export function Terms() {
  useSEO({
    title: 'Terms of Service',
    description: 'Terms governing use of the 888 Sourcing Ltd website and services. UK-registered independent procurement consultancy, Company No. 08400329.',
    path: '/terms'
  });
  return <div className="pt-24 pb-24 bg-navy-dark min-h-screen" data-id="element-930">
      {/* Hero Band */}
      <section className="py-16 px-6 bg-navy-light border-b border-slate-800" data-id="element-931">
        <div className="max-w-4xl mx-auto text-center" data-id="element-932">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-933">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-934">
              <div className="w-12 h-px bg-gold" data-id="element-935"></div>
              <span className="text-gold text-xs font-semibold tracking-widest uppercase" data-id="element-936">
                Legal
              </span>
              <div className="w-12 h-px bg-gold" data-id="element-937"></div>
            </div>
            <h1 className="text-4xl lg:text-5xl font-semibold text-white mb-4" data-id="element-938">
              Terms of Service
            </h1>
            <p className="text-slate-400 text-sm" data-id="element-939">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              year: 'numeric',
              month: 'long'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6" data-id="element-940">
        <div className="max-w-3xl mx-auto" data-id="element-941">
          <div className="space-y-8" data-id="element-942">
            <div data-id="element-943">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-944">
                1. About These Terms
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-945">
                These Terms of Service govern your use of the website operated
                by 888 Sourcing Ltd, a company registered in England and Wales
                (Companies House No. 08400329, VAT No. GB158689350). By
                accessing or using this website, you agree to be bound by these
                terms.
              </p>
            </div>

            <div data-id="element-946">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-947">
                2. Nature of Services
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-948">
                888 Sourcing Ltd is an independent procurement consultancy and
                sourcing intermediary. We facilitate connections between
                suppliers and procurement entities. We are not a party to any
                contract entered into between suppliers and buyers introduced
                through our services unless expressly stated in writing.
              </p>
            </div>

            <div data-id="element-949">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-950">
                3. Independent Consultancy
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-951">
                888 Sourcing Ltd is an independent commercial entity operating
                as a procurement consultancy and sourcing intermediary.
                References on our website to opportunities relating to African
                Union (AU)-funded, multilateral, or government-backed projects
                describe the types of procurement contexts in which we operate
                as an independent consultancy.
              </p>
            </div>

            <div data-id="element-952">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-953">
                4. Supplier Pre-Qualification
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-954">
                Registration as a supplier in our network does not guarantee any
                specific procurement opportunity, contract, or commercial
                outcome. All submissions are reviewed at our discretion. We
                reserve the right to accept, decline, or remove suppliers from
                our network at any time.
              </p>
            </div>

            <div data-id="element-955">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-956">
                5. Information Accuracy
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-957">
                Information provided on this website is for general
                informational purposes. While we make reasonable efforts to
                ensure accuracy, we make no warranty, express or implied,
                regarding the completeness, reliability, or suitability of any
                information for a particular purpose.
              </p>
            </div>

            <div data-id="element-958">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-959">
                6. Intellectual Property
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-960">
                All content on this website, including text, graphics, logos,
                and design, is the property of 888 Sourcing Ltd or its licensors
                and is protected by intellectual property laws. You may not
                reproduce, distribute, or use this content without our prior
                written consent.
              </p>
            </div>

            <div data-id="element-961">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-962">
                7. Limitation of Liability
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-963">
                To the maximum extent permitted by law, 888 Sourcing Ltd shall
                not be liable for any indirect, incidental, special, or
                consequential losses arising out of or in connection with use of
                this website or our services. Nothing in these terms excludes
                liability that cannot be excluded under English law.
              </p>
            </div>

            <div data-id="element-964">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-965">
                8. Third-Party Links
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-966">
                Our website may contain links to third-party sites. We are not
                responsible for the content, accuracy, or practices of such
                sites.
              </p>
            </div>

            <div data-id="element-967">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-968">
                9. Governing Law
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-969">
                These terms are governed by the laws of England and Wales. Any
                disputes shall be subject to the exclusive jurisdiction of the
                English courts.
              </p>
            </div>

            <div data-id="element-970">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-971">
                10. Changes to These Terms
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-972">
                We may update these terms from time to time. Continued use of
                the website after changes constitutes acceptance of the updated
                terms.
              </p>
            </div>

            <div data-id="element-973">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-974">
                11. Contact
              </h2>
              <p className="text-slate-400 leading-relaxed" data-id="element-975">
                For any questions about these terms, please contact us via our{' '}
                <Link to="/contact" className="text-gold hover:underline" data-id="element-976">
                  Contact page
                </Link>{' '}
                or at{' '}
                <a href="mailto:info@888sourcing.co.uk" className="text-gold hover:underline" data-id="element-977">
                  info@888sourcing.co.uk
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}